









































/**
 * External dependencies.
 */
import { Component, Prop, Vue } from 'vue-property-decorator'

/**
 * Internal dependencies.
 */

@Component
export default class UploadPhotoInput extends Vue {
  @Prop({ required: true }) src: string
  @Prop({ type: String, required: true }) inputName: string
  @Prop({ type: String, default: '' }) label: string
  @Prop({ type: Boolean, default: false }) hasErrors: boolean
  @Prop({ type: String, default: '' }) imageClassName: string

  displayInput: boolean = false

  get imageClass () {
    return this.imageClassName || 'avatar rounded-circle mb-4'
  }

  onFileChange (event: any) {
    // release an existing previous object URL (or error is thrown)
    window.URL.revokeObjectURL(event.target.files[0])

    let img: HTMLImageElement | null = new Image()
    img.src = window.URL.createObjectURL(event.target.files[0])
    img.onload = () => {
      this.$emit('success', {
        src: img!.src,
        file: event.target.files[0]
      })

      img = null
    }
    img.onerror = () => {
      this.$emit('error')
    }
  }

  toggleInput () {
    this.displayInput = !this.displayInput
  }
}
